import type { ImageOrVideo } from '@/core/features/image-v2/gallery-type';
import type { MediaSwiperImageOptions, SwiperOptions } from '@/core/features/swiper/media-swiper/media-swiper-types';

import dynamic from 'next/dynamic';

import { logger } from '@/core/features/logger/logger';

const DefaultMediaSlideElement = dynamic(
    () =>
        import(
            /* webpackChunkName: "DefaultMediaSlideElement" */ '@/core/features/swiper/media-swiper/elements/default-media-slide-element'
        ),
);
const PreviewStripeElement = dynamic(
    () =>
        import(
            /* webpackChunkName: "PreviewStripeElement" */ '@/core/features/swiper/media-swiper/elements/preview-stripe-element'
        ),
);

export type MediaElementSwitchProps = {
    hasSmallOverlay?: boolean;
    imageOptions: MediaSwiperImageOptions;
    index: number;
    item: ImageOrVideo;
    swiperOptions: SwiperOptions;
};

export default function MediaElementSwitch(props: MediaElementSwitchProps) {
    const { swiperOptions } = props;
    const { slideElementType = 'default' } = swiperOptions;
    switch (slideElementType) {
        case 'default':
            return <DefaultMediaSlideElement {...props} />;
        case 'preview-stripe':
            return <PreviewStripeElement {...props} />;
        default:
            logger.error(`Missing slideElementType for ${swiperOptions.debugName} component`);
            return <DefaultMediaSlideElement {...props} />;
    }
}
